import React, { useEffect, useState } from "react";
import "./OverviewInt.css";
import InternalBar from "../TopLayout/InternalBar/InternalBar";
import BottomCardGroupInt from "../../BottomCardGroupInt/BottomCardGroupInt";
import { useHistory } from "react-router-dom";
import {cosmosTrackService} from "../../../../cosmosTracking/cosmosTrackService";
import {sale_video_tutor} from "../../../../cosmosTracking/cosmosEvents";
import MessageStudents from "../MessageStudents/MessageStudents";
import { makeApiCal, POST } from "../../util";
import baseURLGlobal from "../../../../utils/util";
import TaskCardMini from "./task-card-mini/taskCardMini";
import {
  resolveTutorDetailsOverviewAsset,
  tutorDetailsOverviewConfig,
  globalColors,
} from './tutorDetailsOverviewConfig';

function OverViewInt(props) { 
  const { data, swipeActions, scrollNav } = props;
  const text = tutorDetailsOverviewConfig.text || {};
  const images = tutorDetailsOverviewConfig.images || {};
  const colors = tutorDetailsOverviewConfig.colors || {};
  const campaignVideo = resolveTutorDetailsOverviewAsset(images.campaign_video);
  const showVideo = tutorDetailsOverviewConfig.video_enabled !== false && Boolean(campaignVideo);
  const overviewPageStyle = {
    '--tutor-details-overview-header-background': globalColors.page_background || 'rgba(254, 242, 223, 1)',
    '--tutor-details-overview-card-border': globalColors.accent_color || '#E35C22',
    '--tutor-details-overview-task-section-background': globalColors.page_background || 'rgba(254, 242, 223, 1)',
    '--tutor-details-overview-heading-highlight': globalColors.accent_color || '#E35C22',
    '--tutor-details-overview-message-heading': colors.message_heading_color || '#040E1A',
    '--tutor-details-overview-message-heading-highlight': colors.message_heading_highlight_color || globalColors.accent_color || '#E35C22',
    '--tutor-details-overview-social-proof-text': globalColors.heading_color || '#232E4F',
    '--tutor-details-overview-task-progress-fill': globalColors.accent_color || '#E35C22',
    '--tutor-details-overview-primary-cta-background': globalColors.accent_color || '#E35C22',
    '--tutor-details-overview-primary-cta-text': globalColors.button_text || '#fff',
  };
  const socialProof = text.social_proof || 'About 80% Teachers won Gifts in this sale';
  const socialProofParts = socialProof.match(/^(\S+\s*)(.*)$/);
  const socialProofPrefix = socialProofParts ? socialProofParts[1] : socialProof;
  const socialProofContent = socialProofParts ? socialProofParts[2] : '';
  const history = useHistory();
  const bottomCard = data?.bottomCard;
  const campaignOrg = data?.campaignOrg;
  const [tutorMsg, setTutorMsg] = useState("");

  const handleSubmitMsg = (message, callback) => {
    const action = {
      method: POST,
      route: 'v1/campaign/tutor/message',
      body: {
        message: message,
        campaignId: campaignOrg?.campaignId
      },
      storeData: (e) => console.log(e),
      catchError: (e) => console.error(e),
    };
    makeApiCal(
      action,
      (data) => {
        callback && callback()
      },
      (error) => {
        console.error('Failure callback:', error);
      }
    );
  }

  const baseUrl = baseURLGlobal;
  const token = new URLSearchParams(window.location.search).get("token");

  const handleEditMsg = () => {
    let myHeaders = new Headers();
		myHeaders.append('api-version', '25');
		myHeaders.append('x-access-token', token);
		let requestOptions = {
			method: 'GET',
			headers: myHeaders
		};
		fetch(`${baseUrl}/v1/campaign/detailPage`, requestOptions)
			.then((response) => response.json())
			.then((result) => {
				setTutorMsg(result?.data?.campaignOrg?.message);
			})
			.catch((error) => console.log('error', error)
    );
  }
  return (
    <>
      <div className="page-content page-content-overview" {...swipeActions} style={overviewPageStyle}>
        <div className="overview-header">
          <img className="header-top-title" src={resolveTutorDetailsOverviewAsset(images.header_banner || 'src/assets/images/banner.png')} />
          <div className="overview-video">
            {showVideo && (
            <video
                key={campaignVideo}
                poster={images.video_poster || 'https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/video-thumbnail-dark.png'}
                src={campaignVideo}
                controls
                controlsList="nofullscreen nodownload noplaybackrate"
                disablePictureInPicture
                playsInline
                onPlay={() => cosmosTrackService(sale_video_tutor)}>
            </video>
            )}
            <div>
              <img src={resolveTutorDetailsOverviewAsset(images.social_proof_icon || 'https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/diwali-overview-graph.png')} alt="img" width={18} height={18}/>
              <h4><span>{socialProofPrefix}</span>{socialProofContent}</h4>
            </div>
          </div>
        </div>
        {data?.campaignOrg?.isPremiumTutor === 1 &&
            <MessageStudents
              onSubmitMessage={handleSubmitMsg}
              onEditMsg={handleEditMsg}
              tutorMsg={tutorMsg}
              config={text}
            />
        }
        <TaskCardMini cards={data?.statCard} scrollNav={scrollNav} config={tutorDetailsOverviewConfig}></TaskCardMini>
        {/* <div className="overview-bottom-card">
          <h2>3x Growth</h2>
          <p>3x your earnings by our Specialised features & get chance to win amazing gifts.</p>
          <BottomCardGroupInt bottomCard={bottomCard} campaignOrg={campaignOrg}></BottomCardGroupInt>
        </div> */}
      </div>
    </>
  );
}

export default OverViewInt;
